import { Container } from "../../components/atoms/Container";
import { Layout } from "../../layout/Layout";
import job from "../../data/job.json";
import { WorkExperience } from "../../components/organisms/WorkExperience";
const ExperiencePage = () => {
  return (
    <Layout
      title="Job Experience about Krutik Parikh"
      description="Work Experience of software developer."
    >
      <Container>
        <h1 className="headline text-3xl md:text-5xl lg:text-6xl mt-8">
          Hi, I&apos;m Krutik Parikh!
        </h1>
        <h2 className="headline text-xl md:text-2xl lg:text-3xl">
          Nice to meet you.
        </h2>
        <h2 className="headline mt-12 mb-4 text-4xl">Experience</h2>

        <WorkExperience jobs={job} />
      </Container>
    </Layout>
  );
};

export default ExperiencePage;
